import { AUTOSUGGEST_REQUEST } from 'actions/AutosuggestActions/AutosuggestActions';
import { logout } from 'actions/LoginSignupActions/logoutActions';
import { AsyncStatus } from 'utils/asyncStatusHelper';
import v4ResponseParser from './V4ResponseParser';
import * as historyParser from './historyParser';
const defaultState = {
    query: null,
    payloadId: null,
    searchHistory: [],
    asyncStatus: AsyncStatus.INIT,
    words: {},
    searchBrowseHistoryRequest: {}
};
export default function autosuggest(state = defaultState, action) {
    switch (action.type) {
        case AUTOSUGGEST_REQUEST.INIT:
            historyParser.initalizeHistory();
            return Object.assign({}, state, {
                asyncStatus: AsyncStatus.INIT,
                searchBrowseRequestHistory: historyParser.getSearchBrowseRequestHistory()
            });
        case AUTOSUGGEST_REQUEST.GET_REQUEST:
            return Object.assign({}, state, {
                asyncStatus: AsyncStatus.LOADING
            });
        case AUTOSUGGEST_REQUEST.GET_HISTORY:
            return Object.assign({}, state, {
                asyncStatus: AsyncStatus.LOADING,
                searchHistory: historyParser.getSearchHistory(action.marketplace)
            });
        case AUTOSUGGEST_REQUEST.SUCCESS:
            return v4ResponseParser(action, state);
        case AUTOSUGGEST_REQUEST.ERROR:
            return Object.assign({}, state, {
                asyncStatus: AsyncStatus.ERROR
            });
        case AUTOSUGGEST_REQUEST.CHANGE_QUERY:
            return Object.assign(Object.assign({}, state), { query: action.query });
        case AUTOSUGGEST_REQUEST.SAVE_HISTORY:
            historyParser.saveAndUpdateHistory(action.marketplace, action.data);
            state.words = {};
            return state;
        case AUTOSUGGEST_REQUEST.SAVE_PLAIN_QUERY_HISTORY:
            historyParser.savePlainQueryInHistory(action.query, action.url, action.marketplace);
            state.words = {};
            return state;
        case logout.LOGOUT_SUCCESS:
            historyParser.deleteHistory();
            return state;
        default:
            return state;
    }
}
